import type { UseFetchOptions } from "#app"
import type { Workspace } from "~/types/api/workspace"

export const workspaceUrl = "/admin/v1/workspace"
export function useWorkspaceSettings(options?: UseFetchOptions<Workspace>) {
  const { $api } = useNuxtApp()
  return useFetch<Workspace>(workspaceUrl, {
    dedupe: "defer",
    $fetch: $api,
    ...options,
  })
}
